import { html, css, LitElement } from 'lit';
import { ContextConsumer } from '@lit/context';
import { organisationContext } from '../../utilities/context';
import { EventManager } from '../../utilities/events';
import { decodeEntities } from '../../utilities/formsUtilities';
import { getTier } from '../../utilities/orgUtilities';
import { formatDateString } from '../../utilities/eventUtilities';
import { formStyles, grid } from '../../utilities/styles.js';
import { AllInConditionals } from '../Utilities/AllInConditionals.js';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
export class AllInOrganisationSubscriptions extends AllInConditionals(AllInOrganisationConsumer(LitElement)) {
    static properties = {
        name: { type: String },
        _invoices: { type: Object, state: true },
        _subscriptions: { type: Object, state: true },
        loading: { type: Boolean, state: true },
        currentOrg: { type: String, state: true },
        groupProfiles: { type: Object, state: true },
        inviteResponse: { type: String, state: true }
    };
    constructor() {
        super();
        this.inviteResponse = '';
    }
    async connectedCallback() {
        super.connectedCallback();
        this.statuses = {
            'paid': `Wedi talu`,
            'open': `Di-d\u00E2l`,
            'void': `Wedi canslo`,
            'uncollectible': `Anghasgladwy `,
        };
        this.durations = {
            'OneYear': `Blwyddyn`,
            'TwoYears': `Dwy Flynedd`,
            'ThreeYears': `Tair Blynedd`,
        };
        if (this.organisation) {
            if (this.organisation.hasOwnProperty('invoices')) {
                this._invoices = this.organisation.invoices;
                this._fetchInvoices();
            }
            else {
                this.loading = true;
                await this._fetchInvoices();
                this.loading = false;
            }
        }
        else {
            this.loading = true;
        }
        this.oldPanel = this.panel;
        await this._fetchGroupProfiles();
    }
    async updated(changedProperties) {
        if (changedProperties.has('currentOrg')) {
            this.organisation = this._getOrganisationById(this.currentOrg);
            if (this.organisation.hasOwnProperty('invoices')) {
                this._invoices = this.organisation.invoices;
                this._fetchInvoices();
            }
            else {
                this.loading = true;
                await this._fetchInvoices();
                this.loading = false;
            }
            this.loading = false;
        }
        if (changedProperties.has('panel') && this.panel !== this.oldPanel) {
            this.oldPanel = this.panel;
            if (this.panel == 'group' && this._isAdmin() && this.groupFlag) {
                let crumb = {
                    organisation: { url: `${this.hardlinks.organisation_dashboard}/${this.currentOrg}/`, title: `${this.organisation?.name}` },
                    dashboard: { url: `${this.hardlinks.organisation_dashboard}/${this.currentOrg}/subscriptions/`, title: `Tanysgrifiadau` },
                    panel: { url: `${this.hardlinks.organisation_dashboard}/${this.currentOrg}/subscriptions/group/`, title: `Rheoli gr\u0175p` }
                };
                this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
                this.eventManager.addHistory(`${this.hardlinks.organisation_dashboard}/${this.currentOrg}/subscriptions/group`, { panel: this.panel });
            }
        }
    }
    _handleContextUpdate(value) {
        this.organisationData = value;
        ({ currentOrg: this.currentOrg, organisations: this.organisations, name: this.name, panel: this.panel, panels: this._panels, restUrl: this.restUrl, nonce: this.nonce, action: this.action } = this.organisationData);
    }
    render() {
        let main;
        if (this._loading) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        const isLeadGroup = this.groupProfiles?.id === this.currentOrg;
        const isAssociateGroup = this.groupProfiles?.associatedOrganisations?.some(org => org.id === this.currentOrg);
        const leadOrgId = this.groupProfiles?.id;
        if (this.panel == 'group' && this._isAdmin() && this.groupFlag) {
            return html `<allin-organisation-subscriptions-group name="${this.name}"></allin-organisation-subscriptions-group>`;
        }
        else {
            let currentSubscription, previousSubscription, unpaidInvoices;
            let notification = '';
            if (this._invoices && Array.isArray(this._invoices?.data) && this._invoices.data.length > 0) {
                previousSubscription = html `<h3>Eich anfonebau blaenorol</h3>\n                ${this._invoices.data.map((invoice) => {
                    if (invoice.status == 'void')
                        return '';
                    let extraLocations = invoice.metadata.extraLocations ? parseInt(invoice.metadata.extraLocations) : 0;
                    let totalBaseLocations = invoice.metadata.totalOrganisations ? parseInt(invoice.metadata.totalOrganisations) : 0;
                    let totalLocations = totalBaseLocations + extraLocations;
                    return html `\n                            <div class="bg">\n                                 <dl class="grid grid_50 gap_4">\n                                    <dt>Status</dt>\n                                    <dd>${this.statuses[invoice.status]}</dd>\n                                    <dt>Lefel tanysgrifio</dt>\n                                    <dd>${getTier(invoice.metadata.tier)}</dd>\n                                    <dt>Cr\u00EBwyd ar</dt>\n                                    <dd>${formatDateString(invoice.created, false, false)}</dd>\n                                    <dt>Hyd y tanysgrifiad</dt>\n                                    <dd>${this.durations[invoice.metadata.duration]}</dd>\n                                    <dt>Nifer y lleoliadau sydd wedi\u2019u cynnwys yn y tanysgrifiad</dt>                                   \n                                    <dd>${totalLocations ? totalLocations : '-'}</dd>\n                                </dl>\n                                <a href="${invoice.hostedInvoiceUrl}" class="button" target="_blank" rel="noopener">Gweld anfoneb</a>\n                            </div>`;
                })}`;
                unpaidInvoices = this._invoices.data.filter((invoice) => invoice.status == 'open' && new Date(invoice.dueDate) > new Date(new Date().setHours(23, 59, 59, 0)));
                if (unpaidInvoices.length > 0) {
                    notification = html `<div class="message">\n                        <h4>Mae gennych ${unpaidInvoices.length == 1 ? 'an ' : ''} anfoneb heb ei thalu${unpaidInvoices.length == 1 ? '' : 's'}</h4>\n                        <ul>\n                           ${unpaidInvoices.map((invoice) => html `\n                            <li>\n                                Mae gennych anfoneb heb ei thalu. Talwch er mwyn manteisio ar y buddion tanysgrifio. \n                                <a href="${invoice.hostedInvoiceUrl}" target="_blank" rel="noopener">\n                                    Gweld anfoneb\n                                </a>\n                            </li>`)}\n                        </ul>\n                    </div>`;
                }
            }
            else if (this._invoices == undefined) {
                previousSubscription = html `<h3>Eich tanysgrifiadau blaenorol</h3><allin-loader loading></allin-loader>`;
            }
            else {
                previousSubscription = html `<h3>Eich tanysgrifiadau blaenorol</h3><p>Does gennych chi ddim tanysgrifiadau blaenorol.</p>`;
            }
            if (this.organisation.subscriptionTier) {
                let button = '';
                let _30daysFromNow = new Date();
                _30daysFromNow.setDate(_30daysFromNow.getDate() + 40);
                if (this._isAdmin()) {
                    if (unpaidInvoices && unpaidInvoices.length > 0) {
                        button = html `\n                        `;
                    }
                    else if (this.organisation?.subscriptionTier == 'Tier1') {
                        button = html `\n                        <button @click="${this._addSubscription}">Ychwanegu tanysgrifiad</button>\n                        `;
                    }
                    else if (this.organisation?.subscriptionEndDate && new Date(this.organisation.subscriptionEndDate) < _30daysFromNow) {
                        button = html `\n                        <button @click="${this._addSubscription}">Adnewyddu tanysgrifiad</button>\n                        `;
                    }
                }
                let subscriptionNote = `Sylwer: Dim ond Prif Weinyddwr all olygu\u2019r tanysgrifiadau.`;
                if (this._isAdmin()) {
                    subscriptionNote = '';
                }
                if (isLeadGroup) {
                    subscriptionNote = html `\n                        Chi yw prif sefydliad tanysgrifiad gr\u0175p.\n                        <a href="/organisation-dashboard/${this.currentOrg}/subscriptions/group" @click="${this._manageGroup}">Rheoli eich gr\u0175p</a>\n                    `;
                    button = '';
                }
                else if (isAssociateGroup) {
                    let invite = this.groupProfiles?.associatedOrganisations?.find(org => org.id === this.currentOrg);
                    if (invite && invite.invitedStatus === 'Accepted') {
                        subscriptionNote = html `\n                            Sylwer: Mae eich tanysgrifiad yn cael ei reoli fel rhan o gr\u0175p. Dim ond y \n                            <a href="/organisation-dashboard/${this.currentOrg}/subscriptions/group" @click="${this._manageGroup}">prif sefydliad</a> all olygu\u2019r tanysgrifiad.\n                        `;
                        button = '';
                        if (this.inviteResponse) {
                            subscriptionNote = html `<div class="invites">\n                                <h4>Eich gwahoddiadau i gr\u0175p tanysgrifio</h4>\n                                <p>${this.inviteResponse}</p>\n                            </div>`;
                        }
                    }
                    else if (invite && (invite.invitedStatus === 'Pending' || invite.invitedStatus === 'Invited')) {
                        let _groupInvites = this.user?.groupInvites?.filter((_invite) => _invite.name == invite.name);
                        if (_groupInvites.length > 0) {
                            subscriptionNote = html `<div class="invites">\n                                <h4>Eich gwahoddiadau i gr\u0175p tanysgrifio</h4>\n                                <ul>\n                                    ${_groupInvites.map((_invite) => {
                                let org = this.organisations.find((org) => org.name == _invite.name);
                                return html `<li>\n                                        <strong>${_invite.name} wedi cael gwahoddiad i ymuno \u00E2 gr\u0175p tanysgrifio</strong>\n                                        <div class="grid grid_50">\n                                            <button @click=${(e) => this._handleGroupInvite(_invite.id, org.org_id, true, e)}>Derbyn y gwahoddiad</button>\n                                            <button @click=${(e) => this._handleGroupInvite(_invite.id, org.org_id, false, e)}>Gwrthod y gwahoddiad</button>\n                                        </div>\n                                    </li>`;
                            })}\n                                </ul>\n                            </div>`;
                            if (this.inviteResponse) {
                                subscriptionNote = html `<div class="invites">\n                                    <h4>Eich gwahoddiadau i gr\u0175p tanysgrifio</h4>\n                                    <p>${this.inviteResponse}</p>\n                                </div>`;
                            }
                            button = '';
                        }
                    }
                }
                if (this._subscriptions && this._subscriptions.length > 0) {
                    let subscriptions = this._subscriptions.sort((a, b) => new Date(b.subscriptionEndDate) - new Date(a.subscriptionEndDate));
                    let currentSubData = subscriptions[0];
                    let subscriptionDuration = currentSubData.subscriptionEndDate && currentSubData.createdAt ? Math.round((new Date(currentSubData.subscriptionEndDate).getYear() - new Date(currentSubData.createdAt).getYear())) : null;
                    currentSubscription = html `<h3>Eich tanysgrifiad presennol</h3>\n                        <div class="bg">\n                            <dl class="grid grid_50 gap_4">\n                                <dt>Lefel tanysgrifio</dt>\n                                <dd>${getTier(currentSubData.tierConfiguration)}</dd>\n                                <dt>Dyddiad prynu</dt>\n                                <dd>${currentSubData.createdAt ? formatDateString(currentSubData.createdAt, false, false) : '-'}</dd>\n                                <dt>Hyd y tanysgrifiad</dt>\n                                <dd>${subscriptionDuration ? `${subscriptionDuration} Year${subscriptionDuration > 1 ? 's' : ''}` : '-'}</dd>\n                                <dt>Diwedd y tanysgrifiad</dt>\n                                <dd>${currentSubData.subscriptionEndDate ? formatDateString(currentSubData.subscriptionEndDate, false, false) : '-'} </dd>\n                                <dt>Nifer y lleoliadau sydd wedi\u2019u cynnwys yn y tanysgrifiad</dt>                                   \n                                <dd>${parseInt(currentSubData.totalLocations)}</dd>\n                            </dl>\n                        </div>\n                        ${button}\n                        <div class="admin-subscr-note">\n                            <p>\n                                ${subscriptionNote}\n                            </p>\n                        </div>\n                    `;
                }
                else {
                    currentSubscription = html `<h3>Eich tanysgrifiad presennol</h3>\n                        <div class="bg">\n                            <dl class="grid grid_50 gap_4">\n                                <dt>Lefel tanysgrifio</dt>\n                                <dd>${getTier(this.organisation.subscriptionTier)}</dd>\n                                <dt>Diwedd y tanysgrifiad</dt>\n                                <dd>${this.organisation.subscriptionEndDate ? formatDateString(this.organisation.subscriptionEndDate, false, false) : '-'}</dd>\n                        </div>\n                        ${button}\n                        <div class="admin-subscr-note">\n                             <p>\n                                ${subscriptionNote}\n                            </p>\n                        </div>\n                    `;
                }
            }
            main = html `${notification}${currentSubscription}${previousSubscription}`;
        }
        return html `<h2>${decodeEntities(this.organisation.name)} tanysgrifiad</h2>${main}`;
    }
    _getOrganisationById(id) {
        return this.organisations.find((org) => org.org_id == id);
    }
    async _fetchInvoices() {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-invoices&nonce=${this.nonce}`;
        try {
            let response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            let data = await response.json();
            //console.log(data);
            this._invoices = data.invoices;
            this._subscriptions = data.subscriptions;
            this.organisation.invoices = this._invoices;
            this.organisation.subscriptions = this._subscriptions;
            this.eventManager.emit(`allin-organisation-${this.name}-update`, { organisation: JSON.stringify(this.organisation) });
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
    }
    _addSubscription() {
        window.location.href = `${this.hardlinks.organisation_dashboard_add_subscription}?org_id=${this.currentOrg}`;
    }
    _manageGroup(e) {
        e.preventDefault();
        this.panel = 'group';
        this._updateContext({ panel: this.panel });
    }
    async _fetchGroupProfiles() {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-group&nonce=${this.nonce}`;
        try {
            let response = await fetch(url, {
                headers: { 'AllIn-Nonce': this.nonce }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            let data = await response.json();
            this.groupProfiles = data.group;
        }
        catch (error) {
            console.error('Error:', error);
        }
    }
    async _handleGroupInvite(inviteId, orgId, accept, e) {
        e.preventDefault();
        const button = e.currentTarget;
        button.disabled = true; // Disable the button to prevent multiple clicks
        button.classList.add('loading'); // Optionally add a loading class for styling
        let url = `${this.restUrl}`;
        try {
            let response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                },
                body: JSON.stringify({
                    invite_id: inviteId,
                    status: accept ? 'Accepted' : 'Rejected',
                    org_id: orgId,
                    action: `${this.action}-handle-group-invite`
                }),
            });
            if (!response.ok) {
                throw new Error(`Server returned ${response.status}`);
            }
            let data = await response.json();
            if (data.ok) {
                // Handle the response data
                let groupInvite = this.user.groupInvites.findIndex(invite => invite.id === inviteId);
                if (groupInvite !== -1) {
                    this.user.groupInvites[groupInvite].inviteStatus = data.status;
                }
                this.inviteResponse = data.status === 'Accepted' ? `Rydych chi wedi llwyddo i dderbyn y gwahoddiad i\u2019r gr\u0175p.` : `Rydych chi wedi gwrthod y gwahoddiad i\u2019r gr\u0175p.`;
                this.user = { ...this.user };
                this._updateContext({ user: this.user });
            }
            else {
                this.inviteResponse = `Gwall wrth brosesu eich cais. Rhowch gynnig arall arni yn nes ymlaen.`;
                console.error('Error handling group invite:', data.error);
            }
        }
        catch (error) {
            console.error('Error handling group invite:', error);
        }
        button.disabled = false;
        button.classList.remove('loading');
    }
    static styles = [
        formStyles,
        grid,
        css `
         .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .gap_4{
            row-gap:1rem;

        }
        dl{
            margin-top:0;
        }
        dl:has(+a){
            margin-bottom:2rem;
        }

        .message{
            background-color: var(--allin-button-bg-color,#fff);
            border: 1px solid var(--allin-button-color,#472961);
            padding:1rem;
            margin-bottom:1rem;
        }

        .message ul{
            list-style:disc;
            padding-left:1rem;
            margin:0;
        }

        .message ul li{
            display:list-item;
        }

        .message ul li a{
            color: var(--allin-button-color,#472961);
            text-decoration: underline;
            padding:0;
            border:none;
            background:transparent;
        }
        .message h4{
            margin-top:0;
        }

        .admin-subscr-note {
            p{
                margin-top: 1rem;
            }
            a{
                color: var(--allin-button-color,#472961);
            }
        }

        .invites ul{
            padding:0;
            .grid{
                gap:1rem;
            }
            li{
                background-color: var(--color-grey);
                padding: 2rem;
                display:block;
                strong{
                    margin-bottom:1rem;
                    display:block;
                }
                button.loading{
                    opacity:0.6;
                    pointer-events:none;
                }
            }
        }

        `
    ];
}
